export default "__VITE_ASSET__ba0c29d2__"